import { render, staticRenderFns } from "./StStage.vue?vue&type=template&id=22b4950a"
import script from "./StStage.vue?vue&type=script&lang=ts"
export * from "./StStage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports